module.exports = __webpack_public_path__ + "statics/img/yhz_android.76ec3aa1.jpg";